import { render, staticRenderFns } from "./schools-home.vue?vue&type=template&id=4e63ddc2"
import script from "./schools-home.vue?vue&type=script&lang=js"
export * from "./schools-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports